module.exports = __webpack_public_path__ + "img/b1f70d7.jpg";